import Vue from 'vue'
import utils from '@/utils/common'
import $ from 'jquery'
Vue.directive("header", {
	inserted: function(el, binding) {
		var handleScroll = () => {
			var value = $(el).height();
			if (binding.value) {
				value = $(binding.value).offset().top + $(binding.value).height()
			}
			// 当滚动到一定距离时显示fixed header
			if ($(document).scrollTop() > value && !$(el).hasClass("sticky")) {
				$(el).addClass("sticky");
				setTimeout(() => {
					$(el).addClass("sticky_animate");
				}, 10);
			} else if ($(document).scrollTop() < value) {
				$(el).removeClass("sticky sticky_animate");
			}
		}
		window.addEventListener('scroll', utils.throttle(handleScroll));

	},
	bind: (el, binding) => {

	}
  // //弹框
	// $(".code-frame").click(function() {
	//   showBg();
	// });
	//
	// function showBg() {
	//   $("#fullbg").css({
	//     height: '100%',
	//     width: '100%',
	//     display: "block"
	//   });
	//   $(".frame").show();
	//   $(".cancel").show();
	// }
	// //关闭灰色 jQuery 遮罩
	// $(".cancel").click(function() {
	//   $("#fullbg,.frame").hide();
	// });
	// //领取码框获取焦点
	// $(".code").focus(function(){
  //    $(".code").css({
  //    	"border-color":"#ff5702",
  //    	"color":"#333333"
  //    })
	// }).blur(function () {
	//   $(".code").css("border-color","#f7e6de")
	// });

});
